import { humanizeRole } from '../../format'
import { RoleCategory } from './types'

export const ROLE_CATEGORIES: RoleCategory[] = [
  { id: 'psychiatrist', label: 'Psychiatrist' },
  { id: 'therapist', label: 'Therapist' },
  { id: 'nutritionist', label: 'Nutritionist' },
  { id: 'care-coordinator', label: 'Care Coordinator' },
  { id: 'coach', label: 'Coach' },
]

export const roleLabelFor = (id: string): string =>
  ROLE_CATEGORIES.find((category) => category.id === id)?.label ?? humanizeRole(id)
